<template>
  <table class="sex-chart-table">
    <tr>
      <td class="sex-chart-table__date-time-header">
        {{dateTimeTitle}}
      </td>
      <td
        class="sex-chart-table__views-header"
        v-for="(item) in headers"
        :key="`header${item}`"
      >
        {{sexConfig[item].text}}
      </td>
    </tr>

    <tr>

      <td class="sex-chart-table__date-time">
        {{sexDate}}
      </td>

      <td
        v-for="(item, key) in sexData"
        class="sex-chart-table__value"
        contenteditable="true"
        @keyup.enter="onEnter($event)"
        @blur="updateChartItem($event, key, item)"
        :key="key"
      >
        {{item}}
      </td>

    </tr>
  </table>
</template>

<script>
  // store
  import { UPDATE_AUDIT_CHART } from "../../../../../store/actions/audit";

  // config
  import sexConfig from "../../../../../config/sexConfig";

  export default {
    name: "SexTable",
    props: {
      data: {
        type: Object
      },
      chartName: {
        type: String
      }
    },
    data() {
      return {
        sexConfig: this.$t('feed.audit.edit.sex.config')
      }
    },
    computed: {
      dateTimeTitle() {
        return this.$t('feed.audit.edit.sex.date');
      },
      headers(){
        return Object.keys(this.data.additional_data.sex);
      },
      sexDate(){
        let from = this.data.from.split(" ");
        let to = this.data.to.split(" ");

        return `c ${from[0]} до ${to[0]}`;
      },
      sexData() {
        return this.data.additional_data.sex;
      }
    },
    methods: {
      onEnter(event) {
        event.target.blur();
      },
      updateChartItem(event, index, key) {
        const value = parseInt(event.target.innerHTML.trim());
        event.target.innerHTML = value;

        this.$store.dispatch(UPDATE_AUDIT_CHART, {
          chart: this.chartName,
          value,
          index,
          key
        })
          .then(() => {
            this.$notify({
              title: this.$t('feed.audit.edit.notify.title'),
              message: this.$t('feed.audit.edit.notify.text'),
              type: 'success',
              duration: 1500,
              showClose: false
            });
          });
      }
    }
  }
</script>

<style>
  .sex-chart-table {
    width: 100%;
    margin-top: 34px;
    font-family: "Roboto", "Arial", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    border-collapse: collapse;
  }

  .sex-chart-table td {
    height: 40px;
    padding: 0 0 0 20px;
    border: 2px solid #EBEBEB;
    box-sizing: border-box;
  }

  .sex-chart-table .sex-chart-table__date-time-header {
    width: 20%;
    color: #5E6D82;
    border-left: transparent;
  }

  .sex-chart-table__views-header {
    width: 20%;
    color: #5E6D82;
    cursor: default;
  }

  .sex-chart-table .sex-chart-table__views-header {
    border-right: transparent;
  }

  .sex-chart-table .sex-chart-table__value {
    border-right: transparent;
  }

  .sex-chart-table .sex-chart-table__date-time {
    border-left: transparent;
  }

  .sex-chart-table__date-time,
  .sex-chart-table__value {
    color: #5E6D82;
  }

  .sex-chart-table__value {
    cursor: text;
  }

  .sex-chart-table__value:hover {
    background-color: #f5f7fa;
  }

  .sex-chart-table__value:focus {
    outline: none;
    background-color: #f5f7fa;
  }
</style>
